import _ from "lodash";
import React from "react";

// import IconQubits from "assets/icons/icon_qubits.svg";
import {SystemCommonDisplay} from "./system_common_display.jsx";

export function CompilerCard(props) {
  const className = `system-card compiler ${props.className ?? ""}`
    + ` ${(props.compiler.available) ? "" : "un"}available`
  ;

  return (
    <div className={className}>
      {/* <IconQubits aria-label={intl.formatMessage({id: "aria.label.icon.qubits"})}/> */}

      <SystemCommonDisplay system={props.compiler}/>
    </div>
  );
}
